import styled from 'styled-components'

const MyDiv = styled.div`
.listView{
  border-radius:8px;
   border-width: 1px;
   cursor:pointer
}
.page_heading{
    margin-bottom: 10px;
}
.flex_header{
    align-items: center;
    justify-content: space-between;
}
.card-wrapper{
    background: #EEF3FB;
    padding: 10px 15px;
    border-radius: 8px;
}
.notification-button{
    column-gap: 10px;
    padding: 5px 10px;
}
.avatar-icon{
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.avatar-icon .chakra-avatar__initials{
    font-size: 16px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
}
.accordion-scroll{
    height: 280px;
    overflow-y: scroll;
}
.cardView{

  border-radius:8px;
   border-width: 1px;
   cursor:pointer
    }
.listView{

  border-radius:8px;
   border-width: 1px;
   cursor:pointer
    }
   
.filterView{
    background-color:rgba(255, 255, 255, 1);
    border-radius:8px;
    border-width: 1px;
    cursor:pointer
    }
`
export default MyDiv
